import React from 'react';
import { motion } from 'framer-motion';
import { Search, SlidersHorizontal, ChevronDown } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const SearchBar = ({ 
  searchQuery, 
  onSearchChange, 
  sortBy, 
  onSortChange, 
  sortOptions,
  onFilterClick,
  totalProducts 
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mb-6 md:mb-8">
      {/* Search Input */}
      <div className="relative flex-1">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground pointer-events-none" />
        <Input
          type="text"
          placeholder="Search our Products"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full h-12 pl-12 pr-4 rounded-full border-border bg-muted/30 focus:bg-background transition-colors"
        />
      </div>

      {/* Mobile Filter Button */}
      <Button
        variant="outline"
        className="md:hidden h-12 rounded-full border-border gap-2"
        onClick={onFilterClick}
      >
        <SlidersHorizontal className="w-4 h-4" />
        Filters
      </Button>

      {/* Sort Dropdown */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <motion.div whileTap={{ scale: 0.98 }}>
            <Button
              variant="default"
              className="h-12 px-6 rounded-full bg-primary text-primary-foreground gap-2"
            >
              {sortOptions.find(opt => opt.id === sortBy)?.name || 'Sorted'}
              <ChevronDown className="w-4 h-4" />
            </Button>
          </motion.div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48 rounded-2xl p-2">
          {sortOptions.map((option) => (
            <DropdownMenuItem
              key={option.id}
              onClick={() => onSortChange(option.id)}
              className={`rounded-xl cursor-pointer ${
                sortBy === option.id ? 'bg-muted' : ''
              }`}
            >
              {option.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SearchBar;
